import React from "react"

interface CheckboxProps {
	props?: any
	className?: string | null
	label?: any
	errMsg?: string
	hasError?: any
	children: any
	trackingOption?: any
}

const ElemCheckbox: React.FC<CheckboxProps> = ({ className, label, errMsg, hasError, children, trackingOption }) => {
	return (
		<label className={"relative block cursor-pointer  " + (className || "")}>
			{children}
			<img
				src={"/images/icon-checkbox.png"}
				alt={"not selected"}
				loading="lazy"
				className="peer-checked:hidden block absolute w-[20px] mr-[20px]"
			/>
			<img
				src={"/images/icon-checkbox-checked.png"}
				alt={"selected"}
				loading="lazy"
				className="peer-checked:block hidden absolute w-[20px] mr-[20px]"
			/>
			<div className="pl-[30px] font-AcuminWide text-white text-[14px] peer-focus-visible:border">{label}</div>
			{hasError && <div className="formErrorMsg js-formerror mb-4   text-red">{errMsg}</div>}
		</label>
	)
}

export default ElemCheckbox
